// extracted by mini-css-extract-plugin
export var bold = "_qz-0";